<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="id"
      :itemNames="['search_name','search_status','create_button',]"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_name" label="商品名称" v-bind="formItemLayout">
        <a-input v-model="queryParams.productName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_status" label="状态" v-bind="formItemLayout">
        <a-select v-model="queryParams.onlineStatus" placeholder="请选择" allowClear style="width:100%;">
          <a-select-option :value="1">在线</a-select-option>
          <a-select-option :value="2">下线</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="onPageSearch">查 询</a-button>
        <a-button style="margin-left:15px" @click="openDialog">手动同步</a-button>
      </a-form-item>
      <div slot="auditSlots" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title" v-if="rowItem.record.auditReason">{{ rowItem.record.auditReason }}</template>
          <div class="pro_title">{{ rowItem.record.auditStatusStr }}</div>
        </a-tooltip>
      </div>
      <div slot="action" slot-scope="rowItem">
        <template v-if="rowItem.record.auditStatus>0">
          <a @click="onEdit(rowItem.record)">编辑</a>
          <template v-if="rowItem.record.auditStatus==1">
            <a-divider type="vertical"/>
            <a v-if="rowItem.record.onlineStatus==1" @click="onlineStatusUpdate(rowItem.record.id,2)">下线</a>
            <a v-if="rowItem.record.onlineStatus==2" @click="onlineStatusUpdate(rowItem.record.id,1)">上线</a>
          </template>
        </template>
      </div>
    </search-page-view>
    <a-modal title="手动同步" :visible="dialogVisible" width="650px" :footer="null" @cancel="handleCancel">
      <a-form-model
        :model="ruleForm" ref="ruleForm" :rules="rules"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="选择店铺" prop="storeId">
          <a-select allowClear v-model="ruleForm.storeId" placeholder="请选择" :disabled="isDisabled">
            <a-select-option v-for="item in storeList" :value="item.id" :key="item.id">{{ item.storeName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="类目选择" required>
          <a-cascader
            style="width: 100%"
            :field-names="{ label: 'name', value: 'category_id', children: 'sub_tree_infos' }"
            :options="categoryList"
            @change="onCategoryChange"
            :value='defaultCategoryValue'
            :showSearch="{ filter }"
            changeOnSelect
            placeholder="类目选择"
          />
        </a-form-model-item>
        <a-form-model-item label="选择商品" required>
          <a-button type="primary" :disabled="isDisabled" @click="toSelectedProductEvent">选择商品</a-button>
          <span v-if="ruleForm.productId" style="margin-left: 3px;">商品ID:{{ ruleForm.productId }}</span>
          <span style="margin-left: 3px;">*仅能关联抢购类型且未上架的自有商品</span>
        </a-form-model-item>
        <a-form-model-item label="商品名称" prop="productName">
          <a-input v-model="ruleForm.productName" placeholder="请输入商品名称" :maxLength="100"></a-input>
        </a-form-model-item>
        <a-form-model-item label="选择类型" prop="productType">
          <a-select allowClear v-model="ruleForm.productType" placeholder="请选择" :disabled="isDisabled">
            <a-select-option v-for="item in goodsTypeList" :value="item.key" :key="item.key">{{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadProductPromise"
      row-key="proId"
      @close="handleProductCancel"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import TiktokMixins from '@/views/service/serviceProvider/tiktokHelper/mixins/TiktokMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'TiktokProductSync',
  components: { SelectedProductDialog },
  mixins: [TiktokMixins],
  data() {
    return {
      ruleForm: {
        firstCategoryId: '',// 第一商品类目ID
        productId: '',// 产品ID
        productName: '',// 商品名称
        productType: undefined,// 商品类型
        secondCategoryId: '',// 第二商品类目ID
        storeId: undefined,// 店铺ID
        thirdCategoryId: ''// 第三商品类目ID
      },
      rules: {
        storeId: [
          { required: true, message: '请选择店铺', trigger: 'change' }
        ],
        productType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        productName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ]
      },
      queryParams: {
        productName: '', //名称
        onlineStatus: undefined
      },
      selectedQueryParams: {
        proName: '',
        proId: '',
        proSource: 0,
        proStatus: 0,
        proType: 8,
        proJoinType: 0
      },
      proTypeList: [],
      storeList: [],
      selectTypeList: [],
      loadPromise: params => this.getListPromise(params),
      loadProductPromise: params => this.getProductListPromise(params),
      dialogVisible: false,
      showSelectedDialog: false,
      submitFormData: '',
      categoryList: [],
      goodsTypeList: [],
      defaultCategoryValue: [8000000],
      isDisabled: false,
      bindId: 0
    }
  },
  mounted() {
    this.getGoodsCategory()
    this.getGoodsType()
    this.getStoreList()
  },
  methods: {
    onPageSearch() {
      this.$refs.table.refresh(true)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('api/douyin/helper/goods/listPage', params)
    },
    getProductListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    handleProductCancel() {
      this.showSelectedDialog = false
    },
    handleCancel() {
      this.dialogVisible = false
    },
    onEdit(record) {
      this.dialogVisible = true
      this.isDisabled = true
      this.ruleForm = { ...record }
      this.bindId = record.id
      // console.error("this.ruleForm",this.ruleForm)
      this.defaultCategoryValue = [this.ruleForm.firstCategoryId, this.ruleForm.secondCategoryId, this.ruleForm.thirdCategoryId]
    },
    openDialog() {
      this.dialogVisible = true
      this.isDisabled = false
      this.bindId = 0
      this.ruleForm = {
        firstCategoryId: '',// 第一商品类目ID
        productId: '',// 产品ID
        productName: '',// 商品名称
        productType: undefined,// 商品类型
        secondCategoryId: '',// 第二商品类目ID
        storeId: undefined,// 店铺ID
        thirdCategoryId: ''// 第三商品类目ID
      }
      this.defaultCategoryValue = [8000000]
    },
    //商品数据点击
    onSelectedResult(record) {
      this.ruleForm.productName = record.proName
      this.ruleForm.productId = record.proId
      this.showSelectedDialog = false
    },
    //选择商品
    toSelectedProductEvent() {
      this.showSelectedDialog = true
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      if (this.defaultCategoryValue.length != 3) {
        this.$message.error('请选择完类目')
        return
      }
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      const queryParams = {
        productId: params.productId,
        productName: params.productName,
        productType: params.productType,
        firstCategoryId: params.firstCategoryId,
        secondCategoryId: params.secondCategoryId,
        thirdCategoryId: params.thirdCategoryId,
        storeId: params.storeId,
        id: this.bindId && this.bindId != 0 ? this.bindId : undefined
      }
      let path = this.bindId && this.bindId != 0 ? 'api/douyin/helper/goods/syncUpdate' : 'api/douyin/helper/goods/sync'
      this.getHttpServices().getProService().post(path, queryParams).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('商品同步成功')
        this.dialogVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    onlineStatusUpdate(id, status) {
      let text = status == 1 ? '上线' : '下线'
      this.getHttpServices().getProService().post('api/douyin/helper/goods/onlineStatusUpdate', { id }).then(res => {
        this.getLogUtils().logWithTag('onlineStatusUpdate', res)
        this.$message.success(text + '成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getGoodsCategory() {
      this.getHttpServices().getProService().post('api/douyin/helper/goods/categoryGet').then(res => {
        this.getLogUtils().logWithTag('getGoodsCategory', res)
        this.categoryList = res && res.length > 0 ? res : []
        this.categoryList.forEach(item => {
          this.$set(item, 'disabled', item.category_id == 8000000 ? false : true)
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getStoreList() {
      this.getHttpServices().getProService().post('api/douyin/helper/store/select').then(res => {
        this.getLogUtils().logWithTag('getStoreList', res)
        this.storeList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getGoodsType() {
      this.getHttpServices().getProService().post('api/douyin/helper/goods/typeGet').then(res => {
        this.getLogUtils().logWithTag('getGoodsType', res)
        this.goodsTypeList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    filter(inputValue, path) {
      return path.some(option => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    onCategoryChange(value, selectedOptions) {
      this.getLogUtils().logWithTag('onCityChange==value', value)
      if (value && value.length) {
        this.ruleForm.firstCategoryId = value[0] ? value[0] : 0
        this.ruleForm.secondCategoryId = value[1] ? value[1] : 0
        this.ruleForm.thirdCategoryId = value[2] ? value[2] : 0
        this.defaultCategoryValue = [value[0], value[1], value[2]]
        this.getLogUtils().logWithTag('onCityChange==this.ruleForm', this.ruleForm)
      } else {
        this.defaultCategoryValue = []
        this.ruleForm.firstCategoryId = 0
        this.ruleForm.secondCategoryId = 0
        this.ruleForm.thirdCategoryId = 0
      }
    },
    getColumns() {
      return [
        {
          title: '店铺名称',
          dataIndex: 'storeName'
        },
        {
          title: '商品名称',
          dataIndex: 'productName'
        },
        {
          title: '类型',
          dataIndex: 'productTypeStr'
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatusStr',
          scopedSlots: { customRender: 'auditSlots' }
        },
        {
          title: '状态',
          dataIndex: 'onlineStatusStr'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }

}
</script>
<style scoped lang="less">

</style>